// public/v3/src/chrome.jsx — top bar (brand, tabs, month, push anchor, avatar, ⋯)
import React from 'react';
import { TABS, tabsForRole } from './lib/tabs';
import { ProgramFilterToggle } from './components/program-filter-toggle';

// Detect whether a month label (e.g. "March 2026") is at or after next month.
// Used to disable the Next-month button — there's no data to bill for the future.
function isFutureMonth(label) {
  const [m, y] = (label || '').split(' ');
  if (!m || !y) return false;
  const candidate = new Date(`${m} 1, ${y}`);
  if (Number.isNaN(candidate.getTime())) return false;
  const now = new Date();
  return candidate.getFullYear() > now.getFullYear()
    || (candidate.getFullYear() === now.getFullYear() && candidate.getMonth() >= now.getMonth() + 1);
}

export function Chrome({ tab, setTab, month, onPrevMonth, onNextMonth, onToday, user, onOpenMore, tabBadges, toolbarTabs, programFilter, setProgramFilter, bhiEnabled, pinEnabled, painEnabled }) {
  const baseTabs = toolbarTabs && toolbarTabs.length ? toolbarTabs : TABS;
  const renderedTabs = tabsForRole(baseTabs, {
    role: user?.role,
    features: user?.features,
    featurePermissionsEnabled: user?.featurePermissionsEnabled,
  });
  const currentTab = renderedTabs.find((t) => t.v === tab) || renderedTabs[0];

  return (
    <div className="chrome">
      <div className="chrome-row">
        <div className="brand-mark" aria-label="ABZ">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
            <path d="M5 20 L12 4 L19 20"
                  stroke="currentColor" strokeWidth="1.7"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7.6 14 L16.4 14"
                  stroke="currentColor" strokeWidth="1.7"
                  strokeLinecap="round"/>
          </svg>
        </div>
        <div className="mobile-current-tab">{currentTab?.full || 'CCM Compliance'}</div>

        <div className="chrome-tabs">
          {renderedTabs.map((t) => (
            <button key={t.v}
              className={`chrome-tab ${tab === t.v ? 'active' : ''}`}
              onClick={() => setTab(t.v)}>
              <span className="label-full">{t.full}</span>
              <span className="label-short">{t.short}</span>
              {tabBadges && tabBadges[t.v] > 0 && (
                <span className="chrome-tab-badge tabnum">{tabBadges[t.v]}</span>
              )}
            </button>
          ))}
        </div>

        <div className="chrome-spacer" />

        <div className="chrome-month">
          <button className="nav-btn" aria-label="Prev month" onClick={onPrevMonth}>‹</button>
          <b>{month}</b>
          <button className="nav-btn" aria-label="Next month" onClick={onNextMonth} disabled={isFutureMonth(month)}>›</button>
          <button className="nav-btn today" onClick={onToday} title="Jump to current month">Today</button>
        </div>

        <ProgramFilterToggle
          value={programFilter}
          onChange={setProgramFilter}
          bhiEnabled={bhiEnabled}
          pinEnabled={pinEnabled}
          painEnabled={painEnabled}
        />

        <div id="push-anchor" />

        <button className="btn ghost icon chrome-more-btn" aria-label="More" title="More" onClick={onOpenMore}>⋯</button>

        <div className="chrome-user">
          <span>{user?.name || ''}</span>
          <div className="avatar av-3">{(user?.name || '').split(' ').map(s => s[0]).slice(0, 2).join('')}</div>
        </div>
      </div>
    </div>
  );
}
